import React, { useState } from 'react';
import { Play, Settings } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { RunningStats } from '../components/RunningStats';
import { CurrentSong } from '../components/CurrentSong';
import { AICoach } from '../components/AICoach';
import { Dashboard } from '../components/Dashboard';
import { SettingsModal } from '../components/SettingsModal';
import { VoiceControl } from '../components/VoiceControl';
import { AppContext } from '../context/AppContext';
import { AppIcon } from '../components/AppIcon';

export const AppDemo = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showStats, setShowStats] = useState(true);

  return (
    <AppContext.Provider value={{ isRunning, setIsRunning, showStats, setShowStats }}>
      <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 p-4 md:p-6">
        <div className="max-w-4xl mx-auto space-y-4">
          <header className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-3">
              <AppIcon size="sm" />
              <h1 className="text-2xl font-bold text-white">Rhythm</h1>
            </div>
            <div className="flex items-center gap-2">
              <VoiceControl />
              <button 
                className="p-2 glass-button" 
                onClick={() => setShowSettings(true)}
              >
                <Settings className="w-6 h-6" />
              </button>
            </div>
          </header>

          <div className="space-y-4">
            {!isRunning ? (
              <>
                <Dashboard />
                <button 
                  onClick={() => setIsRunning(true)}
                  className="w-full glass-button p-6 flex items-center justify-center gap-3 text-xl font-semibold"
                >
                  <Play className="w-6 h-6" />
                  Start Running
                </button>
              </>
            ) : (
              <>
                <RunningStats />
                <CurrentSong />
                <AICoach />
                <button 
                  onClick={() => setIsRunning(false)}
                  className="w-full glass-button p-6 text-xl font-semibold text-red-300"
                >
                  End Run
                </button>
              </>
            )}
          </div>

          <SettingsModal isOpen={showSettings} onClose={() => setShowSettings(false)} />
        </div>
      </div>
    </AppContext.Provider>
  );
};